import { Component } from '@angular/core';
import { ICellRendererAngularComp, IHeaderAngularComp } from 'ag-grid-angular';
import { ICellRendererParams, IHeaderParams } from 'ag-grid-community';
import { RegulationService } from '@pt/api-client';
import { RegulationTypeEnum } from '@pt/pt-models';

@Component({
  selector: 'pt-regulation-type-renderer',
  template: `
    <ng-container [ngSwitch]='true'>
      <ng-container *ngSwitchCase='params.value === RegulationTypeEnum.INTERNAL_PROCEDURE'>
        <span class='badge rounded-pill bg-primary'>{{ params.valueFormatted | async }}</span>
      </ng-container>

      <ng-container *ngSwitchCase='params.value === RegulationTypeEnum.REGULATION'>
        <span class='badge rounded-pill bg-warning text-dark'>{{ params.valueFormatted | async }}</span>
      </ng-container>

      <ng-container *ngSwitchDefault>
        <span>{{ params.valueFormatted | async }}</span>
      </ng-container>
    </ng-container>
  `,
})
export class RegulationTypeRendererComponent implements ICellRendererAngularComp, IHeaderAngularComp {

  public params: any;
  public RegulationTypeEnum = RegulationTypeEnum;

  constructor(private regulationService: RegulationService) {
  }

  agInit(params: any): void {
    this.params = params;
    this.params.valueFormatted = this.regulationService.translateType(this.params.value);
  }

  refresh(params: ICellRendererParams): boolean;
  refresh(params: IHeaderParams): boolean;
  refresh(params: ICellRendererParams | IHeaderParams): boolean {
    return false;
  }

}
